import React from "react";
import "./ChatStyles.css";
import { ReactComponent as MessageIcon } from "../../../assets/icons/Message.svg";

const NoMessage = ({ callBack }) => {
  return (
    <div className="center-items">
      <div className="container-fluid d-flex justify-content-center">
        <div className="message-icon my-4 text-center">
          <MessageIcon />
        </div>
      </div>
      <div className="container-fluid d-flex justify-content-center mb-2">
        <div className="container-fluid text-center">
          <h4 className="primary-text-blue">You're caught up for now</h4>
          <span>You have no unread messages</span>
        </div>
      </div>
      <div className="container-fluid d-flex justify-content-center my-3">
        <button
          style={{ width: "80%" }}
          className="btn primary-btn"
          onClick={callBack}
        >
          Start Chat
        </button>
      </div>
    </div>
  );
};

export default NoMessage;
